import type { CertificateTemplateId } from '../types/certificateTemplate';

/**
 * Valori accettati nella colonna `Courses.certificate`.
 */
export type CourseCertificateValue = 'cert1' | 'cert2' | 'cert3';

/**
 * Mappatura id certificato DB -> template UI.
 * - cert1: default + firma Francesca (gestita a livello branding)
 * - cert2: formazione continua sanità
 * - cert3: default
 */
export const COURSE_CERTIFICATE_VALUE_TO_TEMPLATE_ID: Record<
  CourseCertificateValue,
  CertificateTemplateId
> = {
  cert1: 'cert1',
  cert2: 'cert2',
  cert3: 'cert3',
};

/**
 * Legge il valore template da oggetti corso API (camelCase o snake_case).
 */
export function pickCourseCertificateValue(
  source: object | null | undefined
): string | undefined {
  if (source == null || typeof source !== 'object') return undefined;
  const rec = source as Record<string, unknown>;
  const candidates = [rec.certificate, rec.course_certificate];
  for (const v of candidates) {
    if (typeof v === 'string' && v.trim().length > 0) {
      return v;
    }
  }
  return undefined;
}

/**
 * Fallback obbligatorio: cert3 (template default).
 */
export function normalizeCourseCertificateValue(
  value: string | number | null | undefined
): CourseCertificateValue {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase();
  if (normalized === 'cert1') return 'cert1';
  if (normalized === 'cert2') return 'cert2';
  return 'cert3';
}
